import ScaledBlockViewport from './ScaledBlockViewport'

export default ScaledBlockViewport
